/* eslint-disable */
import React from "react";

function toDate(value) {
  try {
    if (!value) return null;
    if (value?.toDate) return value.toDate();
    if (value?.seconds) return new Date(value.seconds * 1000);
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

function formatDateTime(value) {
  const d = toDate(value);
  if (!d) return "—";

  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function labelStatus(status) {
  const value = String(status || "").toLowerCase();

  if (value === "approved") return "Approved";
  if (value === "rejected") return "Rejected";
  if (value === "reviewing") return "Marked reviewing";

  return "Updated";
}

export default function AbsenceDecisionTimeline({ history = [] }) {
  const rows = Array.isArray(history) ? [...history].reverse() : [];

  return (
    <section style={styles.wrap}>
      <div>
        <div style={styles.eyebrow}>Internal audit trail</div>
        <h4 style={styles.title}>Decision history</h4>
      </div>

      {!rows.length ? (
        <div style={styles.empty}>No decision history yet.</div>
      ) : (
        <div style={styles.list}>
          {rows.map((item, index) => (
            <div key={`${item.decidedAt || index}-${index}`} style={styles.item}>
              <div style={styles.dot} />

              <div style={styles.content}>
                <strong>{labelStatus(item.status)}</strong>

                <span style={styles.meta}>
                  {formatDateTime(item.decidedAt)} · {item.decidedBy || "Admin"}
                </span>

                {item.note ? (
                  <p style={styles.note}>{item.note}</p>
                ) : (
                  <p style={styles.noNote}>No internal note added.</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

const styles = {
  wrap: {
    display: "grid",
    gap: 12,
    padding: 16,
    borderRadius: 20,
    background: "#f8fbff",
    border: "1px solid #e5ebf7",
  },

  eyebrow: {
    fontSize: 11,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    fontWeight: 900,
    color: "#64748b",
  },

  title: {
    margin: "6px 0 0",
    fontSize: 18,
    fontWeight: 950,
    color: "#111827",
  },

  empty: {
    padding: 12,
    borderRadius: 14,
    background: "#fff",
    color: "#64748b",
    fontWeight: 750,
  },

  list: {
    display: "grid",
    gap: 10,
  },

  item: {
    display: "flex",
    gap: 10,
    padding: 12,
    borderRadius: 16,
    background: "#fff",
    border: "1px solid #e8eefb",
  },

  dot: {
    width: 10,
    height: 10,
    borderRadius: 999,
    background: "#2563eb",
    marginTop: 6,
    flex: "0 0 auto",
  },

  content: {
    display: "grid",
    gap: 4,
  },

  meta: {
    fontSize: 12,
    color: "#64748b",
    fontWeight: 700,
  },

  note: {
    margin: 0,
    color: "#334155",
    lineHeight: 1.5,
  },

  noNote: {
    margin: 0,
    color: "#94a3b8",
    fontStyle: "italic",
  },
};